import { Box, Button, Code, Flex, useClipboard } from "@chakra-ui/react"
import React, { FC } from "react"
import { RiCheckLine, RiFileCopyLine } from "react-icons/ri"

interface CopiedButtonProps {
  value: string
}

const CopiedButton: FC<CopiedButtonProps> = ({ value }) => {
  const { hasCopied, onCopy } = useClipboard(value)

  return (
    <Button onClick={onCopy}>
      <Flex w={"full"} alignItems={"start"} justifyContent={"space-between"}>
        <Code textOverflow={"ellipsis"} overflow={"hidden"} bg={"inherit"}>
          {value}
        </Code>
        <Box>{hasCopied ? <RiCheckLine /> : <RiFileCopyLine />}</Box>
      </Flex>
    </Button>
  )
}

export default CopiedButton
